export interface AuGqlError {
	graphQLErrors?: { message: string }[] | null;
	networkError?: {
		error?: {
			errors?: { message: string }[] | null;
		};
	};
}

export abstract class AuErrorAdapter {
	static getTextFromGqlError(
		error: AuGqlError,
		defaultText: string = 'Something went wrong'
	): string {
		if (error.graphQLErrors?.length) {
			return error.graphQLErrors[0].message;
		} else if (error.networkError?.error.errors?.length) {
			return error.networkError.error.errors[0].message;
		} else {
			console.error(error);
			return defaultText;
		}
	}

	static printGqlErrorToConsole(error: AuGqlError): void {
		console.error(
			'NetworkError: ',
			error.networkError,
			'GraphQlError: ',
			error.graphQLErrors
		);
	}
}
